// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkbox-input-item__label--disabled[data-v-11cfc2d7]{pointer-events:none}.checkbox-input-item__input[data-v-11cfc2d7]{margin:0}.checkbox-input-item__input--top[data-v-11cfc2d7]{top:.3125rem;align-self:flex-start}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
